import { DEFAULT_REG_CHANNEL } from '@/config';

const CUSTOMER_SUPPORT_WHATSAPP_PHONE = '6282227776752';

export function buildCustomerSupportWhatsAppUrl(channel = DEFAULT_REG_CHANNEL) {
  const currentChannel = channel || DEFAULT_REG_CHANNEL;
  const url = new URL('https://api.whatsapp.com/send/');
  url.searchParams.set('phone', CUSTOMER_SUPPORT_WHATSAPP_PHONE);
  url.searchParams.set('text', `Channel ID: ${currentChannel}`);
  url.searchParams.set('type', 'phone_number');
  url.searchParams.set('app_absent', '0');
  url.searchParams.set('channel', currentChannel);
  return url.toString();
}
